export const CLEAR_SESSION_AND_USER = 'CLEAR_SESSION_AND_USER';
export const UPDATE_SAVED_SESSION = 'UPDATE_SAVED_SESSION';
export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_FAVORITES = 'UPDATE_FAVORITES';
export const UPDATE_CC_ACTION = 'UPDATE_CC_ACTION';

export const clearSessionAndUser = () => {
    return {
        type: CLEAR_SESSION_AND_USER,
    };
};

export const updateSavedSession = (data: ISavedSession) => {
    return {
        type: UPDATE_SAVED_SESSION,
        payload: data,
    };
};

export const updateUser = (data: { isLoggedIn: boolean; data: IUserData }) => {
    return {
        type: UPDATE_USER,
        payload: data,
    };
};

export const updateFavorites = (count: number) => {
    return {
        type: UPDATE_FAVORITES,
        payload: count,
    };
};

export const updateCcAction = (action: string) => {
    return {
        type: UPDATE_CC_ACTION,
        payload: action,
    };
};
